import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MainService } from 'src/app/services/main/main.service';

@Component({
  selector: 'app-video-tutorials',
  templateUrl: './video-tutorials.component.html',
  styleUrls: ['./video-tutorials.component.scss']
})
export class VideoTutorialsComponent {
  tutorial_videos = [];
  selected_video = { url: null };

  constructor(private mainService: MainService, public dialog: MatDialog) {
    this.getTutorialVideos();
  }
  getTutorialVideos() {
    const data = {
      access_token: localStorage.getItem('token')
    };
    this.mainService.api(data, 'get_tutorial_videos', false)
      .subscribe((data: any) => {
        if (data && data.is_error == 0) {
          this.tutorial_videos = data.data;
          this.selected_video = this.tutorial_videos[0];
        }
        if (data && data.is_error == 1) {
          if (data.override_text) {
            this.mainService.customPopups(data.override_text, data.is_error);
          } else {
            this.mainService.flagPopUps(data.flag, data.is_error);
          }
        }
      },
        (error: any) => {
          console.log(error);
        });
  }

  routeMe() {
    this.mainService.goBack();
  }

  openDialog() {
    this.dialog.open(DialogContentExampleDialog, {
      width: '550px',
      height: '340px',
      panelClass: 'simpleDialog',
      data: {
        data: this.selected_video
      }
    });
  }

}


@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-tutorials.component.scss']
})
export class DialogContentExampleDialog {
  select: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef: MatDialogRef<DialogContentExampleDialog>) {
    this.select = data.data;

  }
}

